'use client';

import { Auth0Provider } from '@auth0/nextjs-auth0/client';
import { ThemeProvider } from 'next-themes';

import { CookieConsentProvider } from '@/entities/cookies-concent';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <Auth0Provider>
        <CookieConsentProvider>{children}</CookieConsentProvider>
      </Auth0Provider>
    </ThemeProvider>
  );
}
